import { scopeClass } from "@dinesh-gamage/react-scoped-css";
import React, { useEffect } from "react";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { FormField, Label, Select } from "uxp/components";
import './PieChartPreview.scss';
export const PieChartPreview = props => {
    var _a;
    const [valueField, setValueField] = React.useState('');
    const [labelField, setLabelField] = React.useState('');
    const type = 'pie';
    const chartSize = 80;
    const colors = ['#5652C2', '#BC59C3', '#BB597B', '#72C1C7', '#ABE087', '#C76663'];
    function getTooltipText(item) {
        return `${item === null || item === void 0 ? void 0 : item[labelField || 'name']} : ${item === null || item === void 0 ? void 0 : item[valueField || 'value']}`;
    }
    let schema = props.schema || [];
    useEffect(() => {
        if (props.schema && !valueField) {
            let item = schema.find(x => x.type == 'number');
            if (item) {
                setValueField(item.name);
            }
        }
        if (schema && !labelField) {
            let item = schema.find(x => x.type == 'string');
            console.log('IMTEIZE', item, schema);
            if (item) {
                setLabelField(item.name);
            }
        }
    }, [props.schema]);
    let numericFields = schema.filter(x => x.type == 'number');
    if (numericFields.length == 0) {
        numericFields = schema;
    }
    return React.createElement("div", { className: "qe-preview-pie-chart-929b7b9a" },
        React.createElement("div", { className: "qe-preview-chart-props-929b7b9a" },
            React.createElement(FormField, null,
                React.createElement(Label, null, "Value"),
                React.createElement(Select, { renderOption: (option, key) => React.createElement("div", { className: scopeClass('qe-chart-select-option ' + (option.type == 'number' ? '' : 'disabled'), "929b7b9a", ["uxpcore-", "uxpcore_", "uxp-", "leaflet-", "react-resizable", "react-grid", "modal-"]) }, option.name), onChange: setValueField, options: schema, labelField: "name", valueField: "name", selected: valueField })),
            React.createElement(FormField, null,
                React.createElement(Label, null, "Label"),
                React.createElement(Select, { renderOption: (option, key) => React.createElement("div", { className: scopeClass('qe-chart-select-option ' + (option.type == 'string' ? '' : 'disabled'), "929b7b9a", ["uxpcore-", "uxpcore_", "uxp-", "leaflet-", "react-resizable", "react-grid", "modal-"]) }, option.name), onChange: setLabelField, options: schema, labelField: "name", valueField: "name", selected: labelField }))),
        React.createElement("div", { className: "qe-preview-929b7b9a" },
            React.createElement("div", { className: "qe-preview-chart-area-929b7b9a" }, valueField && labelField ? React.createElement(ResponsiveContainer, { width: "100%", height: "100%" },
                React.createElement(PieChart, null,
                    React.createElement(Pie, { dataKey: valueField || 'value', labelLine: false, data: (_a = props.data) === null || _a === void 0 ? void 0 : _a.map((x) => {
                            var y = Object.assign({}, x);
                            y[valueField] = Number(y[valueField]);
                            return y;
                        }), fill: "#FFFFFF00", paddingAngle: 1, innerRadius: type == 'pie' ? 0 : `${(chartSize || 80) * 0.67}%`, outerRadius: `${chartSize || 80}%`, cx: "50%", cy: "50%", isAnimationActive: false, label: ({ cx, cy, midAngle, innerRadius, outerRadius, value, name, index }) => {
                            var _a;
                            const RADIAN = Math.PI / 180;
                            const radius = 20 + Number(innerRadius) + (Number(outerRadius) - Number(innerRadius));
                            const x = Number(cx) + radius * Math.cos(-midAngle * RADIAN);
                            const y = Number(cy) + radius * Math.sin(-midAngle * RADIAN);
                            let color = colors[index % colors.length];
                            return React.createElement("text", { x: x, y: y, fill: color, textAnchor: x > Number(cx) ? "start" : "end", dominantBaseline: "central" }, ((_a = props.data[index]) === null || _a === void 0 ? void 0 : _a[labelField]) || '(Unknown)');
                        } }, props.data.map((entry, index) => {
                        let _color = colors[index % colors.length];
                        return React.createElement(Cell, { stroke: '0', fill: _color });
                    })),
                    React.createElement(Tooltip, { content: props => {
                            var _a, _b;
                            return React.createElement("div", { className: "wd-chart-tooltip-929b7b9a" },
                                React.createElement("div", { className: "label-929b7b9a" }, getTooltipText((_b = (_a = props === null || props === void 0 ? void 0 : props.payload) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.payload)));
                        } }),
                    React.createElement(Legend, { formatter: (v, e, i) => { var _a, _b; return ((_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a[i]) === null || _b === void 0 ? void 0 : _b[labelField || 'name']) || 'Unknown'; }, layout: "vertical", verticalAlign: "middle", align: "right" }))) : React.createElement("div", { className: "pie-chart-info-929b7b9a" }, "Select a field to plot"))));
};
